export default {
  path: 'overview',
  component: '@/pages/overview',
  name: '概览',
  icon: 'MeetingFilled',
  accessKey: '/overview',
};
